import { HashRouter  as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from "./pages/Home";
import Links from "./pages/Links";
import Login from "./pages/Login";
import AdminUsers from "./pages/AdminUsers";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
    return (
        <Router>
            <Routes>
                <Route path='/login' element={<Login/>}/>
                <Route path='/' element={<ProtectedRoute><Home/></ProtectedRoute>}/>
                <Route path='/links' element={<ProtectedRoute><Links/></ProtectedRoute>}/>
                <Route path='/g45awer/users' element={<ProtectedRoute requireAdmin={true}><AdminUsers/></ProtectedRoute>}/>
            </Routes>
        </Router>
    );
}

export default App;
